import React, { useContext, useEffect } from 'react';

import cx from 'classnames';

import bullsImg from 'assets/bg/bg.jpeg';
import EditableText from 'components/shared/EditableText';
import Text from 'components/shared/Typography/Text';
import { LANDING_PAGE_ROLES } from 'constants/index';
import i18n from 'i18n';

import FocalImage from '../../../../../../Layouts/Form/FormBuilder/FocalImage';
import { PDFDataContext } from '../../context';
import BodyWrapper from '../../Wrappers/BodyWrapper';
import PageWrapper from '../../Wrappers/PageWrapper';
import TemplatePage from '../TemplatePage';
import s from './index.module.css';

function CoverPage({ onReady }) {
  const PDFData = useContext(PDFDataContext);
  const { title, preparedFor, travelDates, primaryColor, page, showImages } = PDFData;

  const coverPage = page.landing.pages.find((p) => p.role === LANDING_PAGE_ROLES.COVER_PAGE);
  const imageSrc = coverPage.primaryImageVersion800 || coverPage.primaryImageUrl;

  useEffect(() => {
    onReady();
  }, []);

  if (coverPage && !coverPage.hidden) {
    return (
      <PageWrapper>
        <TemplatePage.Header
          border={false}
          renderLeftContent={() => null}
          renderRightContent={() => null}
          {...PDFData}
        />

        <BodyWrapper>
          <div className={cx(showImages && s.imageWrapper)}>
            {showImages && (
              <div className={s.imageBackground}>
                <FocalImage point={coverPage.primaryImageCoords} src={imageSrc} defaultSrc={bullsImg} noLazyLoading />
              </div>
            )}
            <div className={s.contentInner}>
              <Text className={s.prepared} isStrong accent>
                {preparedFor && `${i18n.t('proposal_content.prepared_for')} ${preparedFor}`}
              </Text>
              <Text className={s.title} isStrong accent>
                <EditableText text={coverPage.headline || title} textAlignment="center" isReadonly />
              </Text>
              <div className={s.separator} style={{ background: primaryColor || '#c99048' }} />
              <div className={s.dates}>{travelDates}</div>
            </div>
          </div>
        </BodyWrapper>
      </PageWrapper>
    );
  }

  return null;
}

export default CoverPage;
